import { Button } from "@/components/ui/button";

interface KindQuestionProps {
  busy: boolean;
  onChoose: (kind: "day_ticket" | "program") => void;
}

/** The first thing a festival of unclear type is asked, before anything else on the page is shown. */
export function KindQuestion({ busy, onChoose }: KindQuestionProps) {
  return (
    <section className="flex flex-col gap-3 rounded-lg border p-4">
      <h2 className="text-lg font-semibold">Day ticket or Program?</h2>
      <p className="text-sm text-muted-foreground">
        Day ticket: one event per day. Program: many separate concerts.
      </p>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          disabled={busy}
          onClick={() => onChoose("day_ticket")}
        >
          Day ticket
        </Button>
        <Button
          type="button"
          variant="outline"
          disabled={busy}
          onClick={() => onChoose("program")}
        >
          Program
        </Button>
      </div>
    </section>
  );
}
